import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import { appAccessCodeSelector } from 'store/auth/selectors';

import { useSelector } from 'hooks';

import { getStepProgressData, getTitleKey } from './helpers';

import Circle from './components/Circle';

import * as S from './styled';

import { StepProgressItem, StepProgressProps } from './types';

const StepProgress = ({ isAppDownloaded }: StepProgressProps) => {
    const { t } = useTranslation();
    const appAccessCodeData = useSelector(appAccessCodeSelector);
    const { access_code } = appAccessCodeData ?? {};

    const data: StepProgressItem[] = getStepProgressData(2, access_code);

    return (
        <>
            <Text type="h5" mb={24} bold center>{`${t(getTitleKey(isAppDownloaded, access_code))} 🙌`}</Text>

            {!isAppDownloaded && (
                <S.Container>
                    {data.map(({ id, isFinished, isCurrentStep, label }, index) => (
                        <S.Wrapper key={id}>
                            <Circle id={id} isFinished={isFinished} isCurrentStep={isCurrentStep} label={label} />
                            {index !== data.length - 1 && <S.Line isFinished={isFinished} />}
                        </S.Wrapper>
                    ))}
                </S.Container>
            )}
        </>
    );
};

export default StepProgress;
